<template>
  <div class="form-card">
    <div class="form-card__header">
      <div class="form-card__header-icon"><i class="pi pi-sliders-h"></i></div>
      <div>
        <p class="form-card__title">الإعدادات</p>
        <p class="form-card__subtitle">{{ subtitle }}</p>
      </div>
    </div>
    <div class="form-card__body">
      <div class="settings-list">
        <slot name="before" />
        <label class="settings-row">
          <div class="settings-row__text">
            <span class="settings-row__title">ظاهر في الموقع</span>
            <span class="settings-row__desc">{{ visibleDesc }}</span>
          </div>
          <InputSwitch v-model="form.is_visible" />
        </label>
        <label class="settings-row">
          <div class="settings-row__text">
            <span class="settings-row__title">عرض في الصفحة الرئيسية</span>
            <span class="settings-row__desc">{{ homeDesc }}</span>
          </div>
          <InputSwitch v-model="form.show_on_home" />
        </label>
        <label class="settings-row">
          <div class="settings-row__text">
            <span class="settings-row__title">الاشتراك مطلوب</span>
            <span class="settings-row__desc">يتطلب من الطالب الاشتراك للوصول إلى المحتوى</span>
          </div>
          <InputSwitch v-model="form.is_subscription_enabled" />
        </label>
        <slot name="after" />
      </div>
    </div>
  </div>
</template>

<script>
import InputSwitch from 'primevue/inputswitch';

// Shared "Settings" product-editor section (Courses / Academic Years). Renders the
// three switches common to every subscribable product; entities with extra toggles
// (e.g. Academic Year's is_active) slot their own settings-row in via #before/#after.
export default {
  name: 'ProductSettingsSection',
  components: { InputSwitch },
  props: {
    form: { type: Object, required: true },
    subtitle: { type: String, default: 'التحكم في ظهور المنتج واشتراكه' },
    visibleDesc: { type: String, default: 'يظهر المنتج في الصفحة العامة' },
    homeDesc: { type: String, default: 'يظهر ضمن المنتجات المميزة بالصفحة الرئيسية' },
  },
};
</script>
